export default __webpack_public_path__ + "static/media/travallo_1.6eb3181c.png";